import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const sizeToHeight = {
    sm: pxToRem(32),
    md: pxToRem(40),
};
const sizeToFontSize = {
    sm: theme.fontSize.small,
    md: theme.fontSize.medium,
};
export const Input = styled.input `
  border: none;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  line-height: ${theme.lineHeight.default};
  color: ${theme.semantic.foreground.primary};

  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    color: ${theme.swatches.warm[500]};
  }
`;
export const Adornment = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const outlineInputDisabledStyles = css `
  box-shadow: none;
  border: ${pxToRem(1)} dashed ${theme.semantic.border.strong};
`;
const outlineInputDefaultStyles = css `
  box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.border.default}; /* firefox fallback until :has selector is supported */

  &:has(input:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.border.default};
  }

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.border.default};
  }

  &:has(input:focus-visible:not(:disabled)) {
    background-color: ${theme.semantic.surface.primary};
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.swatches.warm[700]};

    ${Adornment} svg {
      color: ${theme.semantic.text[100]};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.swatches.warm[700]};
  }

  &:has(input:disabled) {
    ${outlineInputDisabledStyles};
  }
`;
const outlineInputInvalidStyles = css `
  box-shadow: 0 0 0 ${pxToRem(1)} ${theme.semantic.text.danger};

  &:hover:not(:has(input:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.text.danger};
  }

  &:has(input:focus-visible:not(:disabled)) {
    background-color: ${theme.semantic.surface.primary};
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.text.danger};

    ${Adornment} svg {
      color: ${theme.semantic.text[100]};
    }
  }

  &:has(input:active:not(:disabled)) {
    box-shadow: 0 0 0 ${pxToRem(2)} ${theme.semantic.text.danger};
  }

  &:has(input:disabled) {
    ${outlineInputDisabledStyles};
  }
`;
export const InputContainer = styled.div `
  min-width: 0;
  height: ${({ $size }) => sizeToHeight[$size]};
  font-size: ${({ $size }) => sizeToFontSize[$size]};
  box-sizing: border-box;
  position: relative;
  width: ${(props) => props.$stretch && '100%;'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: ${theme.spacing.lg};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.md};
  ${(props) => !props.$invalid && outlineInputDefaultStyles};
  ${(props) => props.$invalid && outlineInputInvalidStyles};
  transition: box-shadow 0.15s;
`;
